export default "__VITE_ASSET__D9m$hvr9__"